module.exports = __webpack_public_path__ + "8faff37bcf1ed5bdd67f07ade8a19458.pdf";